import Icon from '../components/Icon.vue'

Icon.register({
  'door-closed': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h112v-397.2c0-28 21.5-50.8 48-50.8h288c26.5 0 48 22.8 48 50.8v397.2h112zM416 288c17.7 0 32-14.3 32-32 0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/door-closed.js
// module id = 1277
// module chunks = 0